import React from 'react';

import BlockSerializer from 'lib/sanity/ui/BlockSerializer';
import { MarketSpecificContent } from 'lib/sanity/types';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { isAvailableInMarkets } from 'lib/sanity/helpers/marketFilter';

interface Props {
  data: MarketSpecificContent;
}

const ArticleMarketSpecificContent = ({ data }: Props) => {
  const {
    market: { marketCode },
  } = useServerSideConstants();
  const { content } = data;

  if (!content || !isAvailableInMarkets(data, marketCode)) {
    return null;
  }

  return <BlockSerializer value={content} />;
};

export default ArticleMarketSpecificContent;
